import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AUTH_TOKEN_KEY } from '@kr/store';

/**
 * Auth token interceptor
 */
@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.#addAuthToken(request));
  }

  /**
   * Add auth token to request if token is present
   * @param request request
   */
  #addAuthToken(request: HttpRequest<any>): HttpRequest<any> {
    const authToken = window.localStorage.getItem(AUTH_TOKEN_KEY);
    const signinReq = request.url.indexOf('signin') >= 0 && request.method !== 'DELETE';
    const assetsI18nReq = request.url.indexOf('assets/i18n') >= 0;

    return !signinReq && !assetsI18nReq && authToken
      ? request.clone({ setHeaders: { Authorization: `Bearer ${authToken}` }, withCredentials: true })
      : request.clone({ withCredentials: true });
  }
}
